import { render, staticRenderFns } from "./WithdrawDetail.vue?vue&type=template&id=48ea6513&scoped=true"
import script from "./WithdrawDetail.vue?vue&type=script&lang=js"
export * from "./WithdrawDetail.vue?vue&type=script&lang=js"
import style0 from "./WithdrawDetail.vue?vue&type=style&index=0&id=48ea6513&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ea6513",
  null
  
)

export default component.exports